import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  DocumentTypeRate,
  CreateDocumentTypeRateRequest,
  UpdateDocumentTypeRateRequest,
  DeleteDocumentTypeRateRequest,
} from './DocumentTypeRates.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/document-types`;

export async function listDocumentTypeRates(
  documentTypeId?: number,
): Promise<PageResult<DocumentTypeRate>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${documentTypeId}/rates`,
    null,
  )) as unknown;

  return result as PageResult<DocumentTypeRate>;
}

export async function createDocumentTypeRate(
  documentTypeId: number,
  obj: CreateDocumentTypeRateRequest[],
): Promise<DocumentTypeRate> {
  const result = (await api.post(
    `${CONTROLLER_URL}/${documentTypeId}/rates`,
    obj,
    null,
  )) as unknown;

  return result as DocumentTypeRate;
}

export async function updateDocumentTypeRate(
  documentTypeId: number,
  obj: UpdateDocumentTypeRateRequest,
): Promise<DocumentTypeRate> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${documentTypeId}/rates/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result as DocumentTypeRate;
}

export async function deleteDocumentTypeRate(
  documentTypeId: number,
  obj: DeleteDocumentTypeRateRequest,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${documentTypeId}/rates/${obj.id}`,
    [obj],
    null,
  )) as unknown;

  return result;
}
